import { render, staticRenderFns } from "./list-video-x.vue?vue&type=template&id=e747636e&scoped=true"
import script from "./list-video-x.vue?vue&type=script&lang=js"
export * from "./list-video-x.vue?vue&type=script&lang=js"
import style0 from "./list-video-x.vue?vue&type=style&index=0&id=e747636e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e747636e",
  null
  
)

export default component.exports